module.exports = __webpack_public_path__ + "4100d083f16434aa3e1153edc67d2ce5.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/feed.png
// module id = 200
// module chunks = 0